/**
 * Yolu API
 * Yolu backend API description 
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FileDto } from './file-dto';
import { ItemDto } from './item-dto';
import { InstalmentDto } from './instalment-dto';


export interface PaymentRequestDto { 
    id: string;
    amount: number;
    amountCurrency: PaymentRequestDto.AmountCurrencyEnum;
    amountInSecondaryCurrency: number;
    amountInSecondaryCurrencyCurrency: PaymentRequestDto.AmountInSecondaryCurrencyCurrencyEnum;
    amountCredit: number;
    amountCreditCurrency: PaymentRequestDto.AmountCreditCurrencyEnum;
    amountToRepay: number;
    amountToRepayCurrency: PaymentRequestDto.AmountToRepayCurrencyEnum;
    interestRate: number;
    durationInDays: number;
    supplierName: string;
    supplierId: string;
    dueDate: string;
    termsAccepted: boolean;
    items?: Array<ItemDto>;
    instalments?: Array<InstalmentDto>;
    status: PaymentRequestDto.StatusEnum;
    type: PaymentRequestDto.TypeEnum;
    paymentMethod: PaymentRequestDto.PaymentMethodEnum;
    companyId: string;
    userId: string;
    directPaymentId?: string;
    files?: Array<FileDto>;
    lateRepaymentDate?: string;
    daysLate?: number;
    lateFee?: number;
    lateFeeApplied?: boolean;
    createdAt: string;
    updatedAt: string;
}
export namespace PaymentRequestDto {
    export type AmountCurrencyEnum = 'USD' | 'NGN';
    export const AmountCurrencyEnum = {
        Usd: 'USD' as AmountCurrencyEnum,
        Ngn: 'NGN' as AmountCurrencyEnum
    };
    export type AmountInSecondaryCurrencyCurrencyEnum = 'USD' | 'NGN';
    export const AmountInSecondaryCurrencyCurrencyEnum = {
        Usd: 'USD' as AmountInSecondaryCurrencyCurrencyEnum,
        Ngn: 'NGN' as AmountInSecondaryCurrencyCurrencyEnum
    };
    export type AmountCreditCurrencyEnum = 'USD' | 'NGN';
    export const AmountCreditCurrencyEnum = {
        Usd: 'USD' as AmountCreditCurrencyEnum,
        Ngn: 'NGN' as AmountCreditCurrencyEnum
    };
    export type AmountToRepayCurrencyEnum = 'USD' | 'NGN';
    export const AmountToRepayCurrencyEnum = {
        Usd: 'USD' as AmountToRepayCurrencyEnum,
        Ngn: 'NGN' as AmountToRepayCurrencyEnum
    };
    export type StatusEnum = 'PENDING' | 'APPROVED' | 'DECLINED' | 'PAST_DUE' | 'PAYMENT_SUBMITTED' | 'INVOICE_SENT' | 'REPAID' | 'REPAID_LATE';
    export const StatusEnum = {
        Pending: 'PENDING' as StatusEnum,
        Approved: 'APPROVED' as StatusEnum,
        Declined: 'DECLINED' as StatusEnum,
        PastDue: 'PAST_DUE' as StatusEnum,
        PaymentSubmitted: 'PAYMENT_SUBMITTED' as StatusEnum,
        InvoiceSent: 'INVOICE_SENT' as StatusEnum,
        Repaid: 'REPAID' as StatusEnum,
        RepaidLate: 'REPAID_LATE' as StatusEnum
    };
    export type TypeEnum = 'PAY_NOW' | 'FLEX_PAY';
    export const TypeEnum = {
        PayNow: 'PAY_NOW' as TypeEnum,
        FlexPay: 'FLEX_PAY' as TypeEnum
    };
    export type PaymentMethodEnum = 'TRANSFER' | 'ON_DELIVERY' | 'CREDIT' | 'NOT_AVAILABLE';
    export const PaymentMethodEnum = {
        Transfer: 'TRANSFER' as PaymentMethodEnum,
        OnDelivery: 'ON_DELIVERY' as PaymentMethodEnum,
        Credit: 'CREDIT' as PaymentMethodEnum,
        NotAvailable: 'NOT_AVAILABLE' as PaymentMethodEnum
    };
}


